<template>
  <b-card class="p-2" body-class="px-3" footer-class="bg-white pb-0">
    <!-- image -->
    <!-- img
      v-if="project.image"
      class="w-100"
      style="height: 180px"
      :src="project.image"
    />
    <div
      v-else
      class="w-100"
      style="height: 180px; background: #ddd">
    </div -->
    <!-- title and location -->
    <div class="mt-3">
      <p
        v-if="project.location"
        class="mb-1"
        style="font-weight: 500"
      >
        <font-awesome-icon class="text-muted" icon="map-marker"/> {{ project.location.name }}, {{ project.location.countryCode }}
      </p>
      <h4>
        <span class="mr-2" v-if="project.status !== 'ACTIVE'">{{project.status}}</span>
        <b>{{ project.title }}</b>
      </h4>
    </div>
    <!-- description -->
    <p class="text-muted">{{ project.excerpt }}</p>

    <div
      class="text-center"
      v-if="project.status === 'ACTIVE' || isRecruiter"
      slot="footer">
      <h4>
        <b-link
          class="p-0"
          variant="primary-link"
          :to="{ name: 'ProjectShow', params: { projectID: project.id } }"
        >
          <b>View Project</b>
        </b-link>
      </h4>
    </div>
  </b-card>

</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    project: {
      type: Object,
    },

    layout: {
      type: String,
      default: () => 'block',
      validate: layout => [ 'block', 'page', 'select-modal' ].includes(layout),
    },
  },
  methods: {
    trackShareEvent({ channel }) {
      const { shareCode } = this.job;
      Promise.resolve(this.$root.captureLog({
        eventName: 'JOB_SHARED',
        job: { share: shareCode },
        user: { share: shareCode },
        referral: { share: shareCode },
        data: channel ? [ { key: 'channel', value: channel } ] : null,
      }));
    },
  },
  computed: {
    ...mapRoot([ 'company', 'isLoggedIn', 'isRecruiter' ]),
    hasMatches() {
      const { matchesTotal } = this.job || {};
      return matchesTotal && matchesTotal.total > 0;
    },
    shareUrl() {
      const { origin } = this.$root;
      return `${origin}/r/${this.job.shareCode}`;
    },
    hideJobExcerpts() {
      const { sitePreferences: { hideJobExcerpts = false } = {} } = this.company;
      return hideJobExcerpts === true;
    },
    toCandidates() {
      return {
        ...this.toJob,
        hash: '#candidates',
      };
    },
  },
};
</script>

<style lang="scss">
.jobs-list-item {

  p {
    margin: 0;
  }

  .contact-picture {
    display: inline-block;
  }

  .jobs-list-header {
    h3 {
      a {
        &, &:hover {
          color: inherit;
          font-weight: inherit;
          text-decoration: none;
        }
      }
    }

    .label {
      border: 1px solid transparent;
      border-radius: 4px;
      line-height: 1.5;
      padding: 0.375rem;
      text-align: center;
      vertical-align: middle;
    }
  }

  .job-image {
    display: block;
    max-width: 150px;
    max-height: 150px;
    width: auto;
    height: auto;
  }

  .jobs-list-row {
    padding-bottom: 20px;
  }

  .btn-primary, .btn-outline-primary {
    border-radius: 4px;
    font-size: 15px;
  }

  .card-footer {
    padding: 10px;

    .row {
      margin-left: 0px;
      margin-right: 0px;
    }

    .btn-primary, .btn-outline-primary {
      border-radius: 4px;
      font-size: 15px;
    }

    h5 {
      line-height: 25px;
      font-size: 15px;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectListItem.vue